import { jsx } from "react/jsx-runtime";
import { StaggerFadeContainer } from "@pcln/horizon";
import { Button, Flex } from "pcln-design-system";
import { useContext, useState } from "react";
import styled_components from "styled-components";
import analytics from "./analytics/analytics.js";
import { ChatbotDataContext } from "./context/ChatbotDataContext.js";
import { useStandaloneStyles } from "./context/StandaloneStyleContext.js";
import { useChatMessagesContext } from "./hooks/useChatMessagesContext.js";
const StyledFlex = /*#__PURE__*/ styled_components(Flex).withConfig({
    displayName: "QuickActions__StyledFlex"
})([
    "overflow-x:auto;",
    " ",
    " ",
    ""
], ({ isStandalone })=>isStandalone && `
      width: fit-content;
      white-space: nowrap;
      flex-wrap: wrap;
      max-width: 100%;
    `, ({ isStandalone, isSingleLine })=>isStandalone && isSingleLine && `
        position: relative;
    `, ({ isSingleLine })=>isSingleLine && `
      width: 100%;
      flex-wrap: nowrap;
      height: 91px;
`);
const StyledButton = /*#__PURE__*/ styled_components(Button).withConfig({
    displayName: "QuickActions__StyledButton"
})([
    "white-space:nowrap;"
]);
const QuickActions = (props)=>{
    const { submitQuickActionMessage, hasOtherMessage, quickActions, isSeparatorMsg, isSingleLine, alignItems = 'center', isStandalone, onScroll } = props;
    const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = useState(true);
    const { quickActionsContainer } = useStandaloneStyles();
    const { isMobile, logFirstMessageSubmitted } = useContext(ChatbotDataContext);
    const { chatMessages } = useChatMessagesContext();
    if (!isSeparatorMsg && (!quickActions.length || hasOtherMessage || !isQuickActionsDisplayed)) return null;
    return /*#__PURE__*/ jsx(StaggerFadeContainer, {
        children: /*#__PURE__*/ jsx(StyledFlex, {
            onScroll: onScroll,
            isStandalone: isStandalone,
            isSingleLine: isSingleLine,
            ...quickActionsContainer,
            flexDirection: "row",
            alignItems: alignItems,
            pb: 2,
            "data-testid": "quick-actions-container",
            children: quickActions.map((action, i)=>/*#__PURE__*/ jsx(Flex, {
                    my: 2,
                    mx: 1,
                    alignItems: "center",
                    children: /*#__PURE__*/ jsx(StyledButton, {
                        boxShadowSize: "sm",
                        variation: "white",
                        onClick: function() {
                            setQuickActionsDisplayedValue(false);
                            analytics.log({
                                label: 'quickActions',
                                message: 'QUICK_ACTION_BUTTON_CLICKED',
                                content: action.label
                            });
                            logFirstMessageSubmitted(chatMessages);
                            submitQuickActionMessage(action);
                        },
                        width: isMobile ? 1 : '',
                        children: `${action?.emoticon ?? ''} ${action.label}`
                    })
                }, `quick-action-button-${i}`))
        })
    });
};
export { QuickActions };
